import tagTester from './_tagTester.js';

export default tagTester('Symbol');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isSymbol.js
// module id = 965
// module chunks = 1